<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    class="w-6 h-6"
  >
    <!-- Outline buku / artikel -->
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h7l7 7v9a2 2 0 01-2 2z"
    />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12 7h5M12 11h5M12 15h5"
    />
  </svg>
</template>

<script>
export default {
  name: "ArticleIcon"
}
</script>

<style scoped>
svg {
  display: block;
  color: currentColor;
}
</style>
